import DasboardNotificationsListReducer from './dashboardNotificationsList';

const dashboardRootReducer = {
  dashboardNotificationsList: DasboardNotificationsListReducer,
};

export { dashboardRootReducer };
